export default __webpack_public_path__ + "static/media/Trash.82749b3b.svg";